import React from 'react';

class Carousel extends React.Component{

    static defaultProps = {
        items: [
            {image:"//dummyimage.com/1024x560.png/26a645/ffffff",link:"./"},
            {image:"//dummyimage.com/1024x560.png/0F81C7/ffffff",link:"./"},
            {image:"//dummyimage.com/1024x560.png/f0df0b/ffffff",link:"./"},
            {image:"//dummyimage.com/1024x560.png/FF304F/ffffff",link:"./"}
        ],
        activeIndex: 1
    };
    
    render(){
        const { items, activeIndex } = this.props;
        return (
            <div id="carousel" className="carousel slide" data-ride="carousel">
              <ol className="carousel-indicators">
                {items && items.length > 0 ? items.map((item,key) =>
                    (
                    <li data-target="#carouselExampleIndicators" data-slide-to={key} key={key} className={(key===activeIndex)?'active':''}></li>
                    )
                ):null}
              </ol>
              <div className="carousel-inner">
                {items && items.length > 0 ? items.map((item,key) =>
                    (
                    <div className={(key===activeIndex)?'carousel-item active':'carousel-item'} key={key}>
                        <img className="d-block w-100" src={item.image} alt={'slider ' + key}  />
                    </div>
                    )
                ):null}
              </div>
              <a className="carousel-control-prev" href="#carousel" role="button" data-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="sr-only">Previous</span>
              </a>
              <a className="carousel-control-next" href="#carousel" role="button" data-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="sr-only">Next</span>
              </a>
            </div>
            
            
        );
    }
}

export default Carousel;
